
import React from 'react';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedAddFundsStepWithI18n } from './delayed-add-funds-step';

export const AddFundsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.ADD_FUNDS,
  render: () => <DelayedAddFundsStepWithI18n />,
};

export const PreviewAddFundsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ADD_FUNDS,
  render: () => <DelayedAddFundsStepWithI18n />,
};
